// App root: path-router that mounts the landing page, the public booking flow
// (per host slug), the manage (cancel/reschedule) page, and the host admin page.
// Implements: ADR-0002 section 5 (landing at /, booking at /{slug}, admin at
// /admin, manage scoped to the booking's host).

import type { JSX } from 'react';
import './tokens.css';
import './app.css';
import { useLinkInterception, useRoute } from './lib/router.js';
import { navigate } from './lib/router.js';
import { LandingPage } from './pages/LandingPage.js';
import { BookingPage } from './pages/BookingPage.js';
import { AdminPage } from './pages/AdminPage.js';
import { ManagePage } from './pages/ManagePage.js';
import { BrandShell } from './components/BrandShell.js';
import { StateBlock } from './components/feedback.js';

export function App(): JSX.Element {
  const route = useRoute();
  // Keep internal link clicks client-side (History API) instead of full reloads.
  useLinkInterception();

  switch (route.name) {
    case 'landing':
      return <LandingPage />;
    case 'admin':
      return <AdminPage />;
    case 'booking':
      return <BookingPage slug={route.slug} eventSlug={route.eventSlug} />;
    case 'manage':
      return <ManagePage slug={route.slug} token={route.token} />;
    case 'notfound':
    default:
      return (
        <BrandShell>
          <StateBlock
            title="Page not found"
            action={
              <button type="button" className="btn btn-ghost" onClick={() => navigate('/')}>
                Go to the home page
              </button>
            }
          >
            That link does not point anywhere we recognise.
          </StateBlock>
        </BrandShell>
      );
  }
}
